import { useEffect, useState } from 'react'

import { useAdobeTargetContext } from '@cox/core-ui8/dist/AdobeTargetContext'
import { RuleType } from '@cox/core-ui8/dist/types'
import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'

import { useInversionFlags } from '../../../../hooks/useInversionFlags'
import { NEW_RELIC_ACTION_NAME, triggerNewRelicAction } from '../../../../utils/newrelic-util'
import { getConditionResult } from '../../../../utils/rule-builder-util'
import RuleResultsRenderer from '../RuleResultsRenderer'

const RuleTypeRenderer = (props: {
  ruleId: string
  resultsTrue: any
  resultsFalse: any
  ruleType: string
  condition?: string
  ruleExpression?: string
  isInEditor?: boolean
  componentTypeRenderer?: any
  compName?: string
  defaultVariationContent?: any
  showDefaultContent?: boolean
}) => {
  const {
    ruleId,
    resultsTrue,
    resultsFalse,
    ruleType,
    condition = '',
    ruleExpression = '',
    isInEditor = false,
    componentTypeRenderer,
    compName = '',
    defaultVariationContent,
    showDefaultContent
  } = props
  const flexOffers = useFlexOffers(ruleExpression)
  const [results, setResults] = useState([])
  const [error, setError] = useState<any>()
  const displayResults = results?.length > 0 || (results && Object.keys(results).length > 0)
  const { inversionProperties, isLocal } = useInversionFlags()
  const displayInversionComponent = () => {
    if (ruleType === RuleType.conditional && ruleExpression) {
      return getConditionResult(ruleExpression, {}, 0, isLocal, inversionProperties)
    } else if (ruleType === RuleType.udoconditional && ruleExpression) {
      return ruleExpression
    }
    return false
  }
  const { register, unregister } = useAdobeTargetContext()

  useEffect(() => {
    if (displayResults) {
      /**Rule Type Renderer Component registers with rule Id
       * Rule Results Renderer Component unregisters with rule Id */
      register(ruleId)
      return () => {
        unregister(ruleId)
      }
    }
  }, [])

  useEffect(() => {
    const utagData: any = window?.utag_data
    if (utagData && Object.keys(utagData).length > 0 && ruleId) {
      utagData.rulesRendered?.length > 0 ? utagData.rulesRendered?.push(ruleId) : (utagData.rulesRendered = [ruleId])
    }
    if (isInEditor) {
      setResults(resultsTrue)
      return
    }
    if (ruleType === RuleType.pricing) {
      if ((flexOffers && flexOffers?.success && flexOffers?.offers?.length > 0) || flexOffers?.loading) {
        setResults(resultsTrue)
      } else if (showDefaultContent && flexOffers?.error) {
        setResults(defaultVariationContent)
      } else if (flexOffers?.error) {
        setResults(resultsFalse)
      }
    } else if (ruleType === RuleType.udoconditional) {
      setResults(resultsTrue || resultsFalse)
    } else if (ruleType === RuleType.conditional) {
      try {
        if (isLocal) {
          setResults(displayInversionComponent() ? resultsTrue : resultsFalse)
        } else {
          setResults(eval(ruleExpression) ? resultsTrue : resultsFalse)
        }
      } catch (err) {
        const errorDesc = `Check the rule id: ${ruleId} with rule expression: ${ruleExpression}`
        setError(err)
        console.error(errorDesc, err)
        triggerNewRelicAction({
          errorMessage: errorDesc,
          errorName: `${compName}: Rule Expression Error`,
          actionName: NEW_RELIC_ACTION_NAME.RULE_EXPRESSION_ERROR
        })
      }
    }
  }, [flexOffers])

  if (error) {
    // This error is handled by the ErrorBoundary in the parent component.
    return <>{error}</>
  }

  if (displayResults) {
    return (
      <div id='rule-results' className='rule-results' data-testid={ruleId}>
        <RuleResultsRenderer
          ruleId={ruleId}
          results={results}
          condition={condition as any}
          ruleType={ruleType as RuleType}
          ruleExpression={ruleExpression}
          isInEditor={isInEditor}
          componentTypeRenderer={componentTypeRenderer}
        />
      </div>
    )
  }
  return <></>
}
export default RuleTypeRenderer
